module.exports = __webpack_public_path__ + "img/trespa_express_logo.9439d706.png";